import { render, staticRenderFns } from "./DetailData.vue?vue&type=template&id=af4fd970&scoped=true&"
import script from "./DetailData.vue?vue&type=script&lang=js&"
export * from "./DetailData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4fd970",
  null
  
)

export default component.exports